import { currencyField } from "../../../../services/validate";
import { BaSeGrid, BaSeGridItem } from "@base/react";
import TitleWithPopover from "../../../../components/title-with-popover";
import FormBuilder from "../../../../components/form-builder/form-builder";
import * as Yup from "yup";
import FormInput from "../../../../components/form-builder/form-input";
import Button from "../../../../components/button/button";

const monthlyAverageValidation = Yup.object().shape({
  rtp: currencyField(),
  rts: currencyField("Serviços"),
  cmp: currencyField(),
  cms: currencyField("Serviços"),
  cif: currencyField("Valor"),
});

const MonthlyAverage = ({ data, isDisabled, onChange, onSubmit, postCredit, lab = false }) => {
  const handleSubmit = (values) => {
    if (onSubmit) {
      onSubmit(values);
    } else {
      onChange(null, values);
    }
  };

  return (
    <div className="step monthly-average">
      <div className="step--info">
        <h3 className="step--title">
          Registro das receitas e despesas mensais do negócio.
        </h3>
        <h5 className="step--subtitle">
          Os campos são opcionais, mas para garantir resultados mais precisos,
          preencha todas as informações disponíveis.
        </h5>
      </div>

      <FormBuilder
        initialValues={data}
        validationSchema={monthlyAverageValidation}
        onSubmit={handleSubmit}
      >
        <BaSeGrid>
          <BaSeGridItem
            desktop={{
              size: (lab || postCredit) ? 12 : 6,
              startAt: undefined,
            }}
          >
            <TitleWithPopover
              title="Receita total"
              messagePopover="Para negócios em funcionamento, insira o valor médio mensal das vendas dos últimos três meses. Se você está planejando um novo negócio, informe o valor da meta estabelecida para a receita mensal."
            />
            <BaSeGrid>
              <BaSeGridItem size={6}>
                <FormInput
                  id="rtp"
                  name="rtp"
                  type="currency"
                  isDisabled={isDisabled}
                  label="Produtos"
                  onExternalBlur={onChange}
                />
              </BaSeGridItem>
              <BaSeGridItem size={6}>
                <FormInput
                  id="rts"
                  name="rts"
                  type="currency"
                  isDisabled={isDisabled}
                  label="Serviços"
                  onExternalBlur={onChange}
                />
              </BaSeGridItem>
            </BaSeGrid>
          </BaSeGridItem>
          <BaSeGridItem
            desktop={{
              size: (lab || postCredit) ? 12 : 6,
              startAt: undefined,
            }}
          >
            <TitleWithPopover
              title="Custo com mercadorias"
              messagePopover={[
                "Para negócios em funcionamento, informe o valor médio dos custos dos últimos três meses.",
                "\n\nCaso esteja planejando um novo negócio, insira o custo das mercadorias de acordo com a meta de vendas mensais estabelecida.",
              ]}
            />
            <BaSeGrid>
              <BaSeGridItem size={6}>
                <FormInput
                  id="cmp"
                  name="cmp"
                  type="currency"
                  isDisabled={isDisabled}
                  label="Produtos"
                  onExternalBlur={onChange}
                />
              </BaSeGridItem>
              <BaSeGridItem size={6}>
                <FormInput
                  id="cms"
                  name="cms"
                  type="currency"
                  isDisabled={isDisabled}
                  label="Serviços"
                  onExternalBlur={onChange}
                />
              </BaSeGridItem>
            </BaSeGrid>
          </BaSeGridItem>
          <BaSeGridItem
            desktop={{
              size: (lab || postCredit) ? 12 : 6,
              startAt: undefined,
            }}
          >
            <TitleWithPopover
              title="Custos Indiretos Fixos"
              messagePopover="Informe a soma de todos os custos fixos mensais, como aluguel e outras despesas recorrentes."
            />
            <BaSeGrid>
              <BaSeGridItem size={6}>
                <FormInput
                  id="cif"
                  name="cif"
                  type="currency"
                  isDisabled={isDisabled}
                  label="Valor"
                  onExternalBlur={onChange}
                />
              </BaSeGridItem>
            </BaSeGrid>
          </BaSeGridItem>
        </BaSeGrid>
        {postCredit && (
          <div className="send-button">
            <Button type="submit" disabled={isDisabled}>
              Atualizar
            </Button>
          </div>
        )}
      </FormBuilder>
    </div>
  );
};

export default MonthlyAverage;
